// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
import { classNames, Keys, // useDir, 
getTabIndex, guid } from '@progress/kendo-vue-common';
import { validatePackage } from '@progress/kendo-vue-common';
import { packageMetadata } from '../package-metadata';
import { Picker } from './Picker';
import { ColorPalette, DEFAULT_PRESET, DEFAULT_TILE_SIZE } from './ColorPalette';
/**
 * @hidden
 */

var DEFAULT_GRADIENT_SETTINGS = {
  opacity: true
};
/**
 * @hidden
 */

var DEFAULT_PALETTE_SETTINGS = {
  palette: DEFAULT_PRESET,
  tileSize: DEFAULT_TILE_SIZE
};
/**
 * @hidden
 */

var isControlled = function isControlled(prop) {
  return prop !== undefined;
}; // tslint:enable:max-line-length


var ColorPicker = {
  name: 'KendoColorPicker',
  props: {
    value: {
      type: String,
      default: undefined
    },
    defaultValue: String,
    disabled: Boolean,
    dir: String,
    id: String,
    ariaLabelledBy: String,
    ariaDescribedBy: String,
    paletteSettings: {
      type: Object,
      default: function _default() {
        return DEFAULT_PALETTE_SETTINGS;
      }
    },
    valid: {
      type: Boolean,
      default: true
    },
    tabIndex: {
      type: Number,
      default: 0
    },
    title: String,
    icon: String,
    iconClassName: String,
    popupSettings: Object,
    open: {
      type: Boolean,
      default: undefined
    },
    size: {
      type: String,
      default: 'medium',
      validator: function validator(value) {
        return [null, 'small', 'medium', 'large'].includes(value);
      }
    },
    rounded: {
      type: String,
      default: 'medium',
      validator: function validator(value) {
        return [null, 'small', 'medium', 'large', 'pill'].includes(value);
      }
    },
    fillMode: {
      type: String,
      default: 'solid',
      validator: function validator(value) {
        return [null, 'solid', 'flat', 'outline'].includes(value);
      }
    }
  },
  data: function data() {
    return {
      focused: false,
      stateValue: '',
      stateOpen: false
    };
  },
  computed: {
    isValueControlled: function isValueControlled() {
      return isControlled(this.$props.value);
    },
    isOpenControlled: function isOpenControlled() {
      return isControlled(this.$props.open);
    },
    computedValue: function computedValue() {
      return this.isValueControlled ? this.$props.value : this.stateValue;
    },
    computedOpen: function computedOpen() {
      return this.isOpenControlled ? this.$props.open : this.stateOpen;
    },
    computedIconClassName: function computedIconClassName() {
      var icon = this.$props.icon;
      return this.$props.iconClassName || icon && "k-icon k-i-" + icon;
    },
    wrapperClassName: function wrapperClassName() {
      return {
        'k-widget': true,
        'k-colorpicker': true,
        'k-state-invalid': this.valid === false
      };
    },
    spanClassName: function spanClassName() {
      var disabled = this.$props.disabled;
      return {
        'k-picker-wrap': true,
        'k-state-disabled': disabled,
        'k-state-focused': this.focused
      };
    }
  },
  created: function created() {
    validatePackage(packageMetadata);
    this.focusableElementGuid = guid();
  },
  mounted: function mounted() {
    this.focusableElement = this.$refs[this.focusableElementGuid];
    this.button = this.v3 ? this.buttonRef : this.$refs.button;
    this.palette = this.v3 ? this.paletteRef : this.$refs.palette;
  },
  updated: function updated() {
    this.button = this.v3 ? this.buttonRef : this.$refs.button;
    this.palette = this.v3 ? this.paletteRef : this.$refs.palette;
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var _this2 = this;

    var _this = this;

    var h = gh || createElement;
    var _a = this.$props,
        disabled = _a.disabled,
        tabIndex = _a.tabIndex; // const dir = useDir(focusableElementGuid, props.dir);

    return h("span", {
      "class": this.wrapperClassName
    }, [h("span", {
      id: this.$props.id,
      attrs: this.v3 ? undefined : {
        id: this.$props.id,
        "aria-labelledby": this.$props.ariaLabelledBy,
        "aria-describedby": this.$props.ariaDescribedBy,
        tabIndex: getTabIndex(tabIndex, disabled),
        title: this.$props.title
      },
      "aria-labelledby": this.$props.ariaLabelledBy,
      "aria-describedby": this.$props.ariaDescribedBy,
      "class": this.spanClassName,
      ref: this.focusableElementGuid,
      tabIndex: getTabIndex(tabIndex, disabled),
      title: this.$props.title,
      onKeydown: this.onKeyDownHandler,
      on: this.v3 ? undefined : {
        "keydown": this.onKeyDownHandler,
        "focusin": this.onFocusHandler,
        "focusout": this.onBlurHandler
      },
      onFocusin: this.onFocusHandler,
      onFocusout: this.onBlurHandler
    }, [!this.computedIconClassName ? h("span", {
      onClick: this.onActiveColorClickHandler,
      on: this.v3 ? undefined : {
        "click": this.onActiveColorClickHandler
      },
      "class": 'k-selected-color',
      style: {
        backgroundColor: this.computedValue
      }
    }, [!this.computedValue && h("span", {
      "class": 'k-icon k-i-line'
    })]) : h("span", {
      onClick: this.onActiveColorClickHandler,
      on: this.v3 ? undefined : {
        "click": this.onActiveColorClickHandler
      },
      "class": classNames('k-tool-icon', this.computedIconClassName)
    }, [h("span", {
      "class": 'k-selected-color',
      style: {
        backgroundColor: this.computedValue
      }
    })]), h("span", {
      onClick: this.onClickHandler,
      on: this.v3 ? undefined : {
        "click": this.onClickHandler
      },
      "class": 'k-select',
      ref: this.v3 ? function (el) {
        _this.buttonRef = el;
      } : 'button'
    }, [h("span", {
      "class": 'k-icon k-i-arrow-s'
    })]), // @ts-ignore function children
    h(Picker //  dir={dir}
    , {
      open: this.computedOpen,
      attrs: this.v3 ? undefined : {
        open: this.computedOpen,
        popupAnchor: this.focusableElementGuid
      },
      onOpen: this.onOpenHandler,
      on: this.v3 ? undefined : {
        "open": this.onOpenHandler
      },
      popupAnchor: this.focusableElementGuid
    }, this.v3 ? function () {
      return [// @ts-ignore function children
      h(ColorPalette, {
        onKeydown: _this2.onKeyDownHandler //      {...paletteSettings}
        ,
        on: _this2.v3 ? undefined : {
          "keydown": _this2.onKeyDownHandler,
          "change": _this2.onPaletteChangeHandler
        },
        ref: _this2.v3 ? function (el) {
          _this.paletteRef = el;
        } : 'palette',
        value: _this2.computedValue || undefined,
        attrs: _this2.v3 ? undefined : {
          value: _this2.computedValue || undefined
        },
        onChange: _this2.onPaletteChangeHandler
      })];
    } : [h(ColorPalette, {
      onKeydown: _this2.onKeyDownHandler,
      on: _this2.v3 ? undefined : {
        "keydown": _this2.onKeyDownHandler,
        "change": _this2.onPaletteChangeHandler
      },
      ref: _this2.v3 ? function (el) {
        _this.paletteRef = el;
      } : 'palette',
      value: _this2.computedValue || undefined,
      attrs: _this2.v3 ? undefined : {
        value: _this2.computedValue || undefined
      },
      onChange: _this2.onPaletteChangeHandler
    })])])]);
  },
  methods: {
    focusElement: function focusElement() {
      if (this.focusableElement) {
        this.focusableElement.focus();
      }
    },
    setOpen: function setOpen(nextOpen, isBlur) {
      if (!this.isOpenControlled) {
        if (!nextOpen && !isBlur && this.focusableElement) {
          this.focusableElement.focus();
        }

        this.stateOpen = nextOpen;
      }
    },
    onKeyDownHandler: function onKeyDownHandler(event) {
      var altKey = event.altKey,
          keyCode = event.keyCode;

      if (keyCode === Keys.esc) {
        this.setOpen(false);
        return;
      }

      if (keyCode === Keys.enter && !this.isOpenControlled) {
        event.preventDefault();
        event.stopPropagation();
        this.setOpen(!this.computedOpen);
        return;
      }

      if (altKey && (keyCode === Keys.up || keyCode === Keys.down)) {
        event.preventDefault();
        event.stopPropagation();

        if (keyCode === Keys.up && this.focusableElement) {
          this.focusableElement.focus();
          this.setOpen(false);
        }

        if (keyCode === Keys.down) {
          this.setOpen(true);
        }
      }
    },
    onOpenHandler: function onOpenHandler() {
      // Skip content autofocus when in controlled mode
      if (!this.isOpenControlled) {
        if (this.palette) {
          this.palette.focus();
        }
      }
    },
    onClickHandler: function onClickHandler() {
      this.setOpen(!this.computedOpen, true);
    },
    onActiveColorClickHandler: function onActiveColorClickHandler(event) {
      this.$emit('activecolorclick', {
        event: event,
        value: this.computedValue
      });
    },
    onFocusHandler: function onFocusHandler(event) {
      if (this.blurTimeoutRef) {
        clearTimeout(this.blurTimeoutRef);
        this.blurTimeoutRef = undefined; // case where moving back to input from popup
        // if (event.target === this.focusableElement) {
        //     this.setOpen(false); // in this case we should focus input on keydown
        // }
      } else {
        this.focused = true;
      }

      this.$emit('focus', {
        event: event
      });
    },
    onBlurTimeout: function onBlurTimeout() {
      if (this.palette && document.activeElement !== this.palette.$el) {
        this.setOpen(false, true);
        this.focused = false;
      }

      this.blurTimeoutRef = undefined;
    },
    onBlurHandler: function onBlurHandler(event) {
      clearTimeout(this.blurTimeoutRef);
      this.blurTimeoutRef = window.setTimeout(this.onBlurTimeout, 200);
      this.$emit('blur', {
        event: event
      });
    },
    onChangeHandler: function onChangeHandler(event, isPalette) {
      var currentValue = isPalette ? event.rgbaValue : event.value;

      if (!this.isValueControlled) {
        this.stateValue = currentValue;
      }

      if (isPalette) {
        this.setOpen(false);
      }

      this.$emit('change', {
        value: currentValue,
        event: event
      });
    },
    onPaletteChangeHandler: function onPaletteChangeHandler(event) {
      this.onChangeHandler(event, true);
    }
  }
};
var ColorPickerVue3 = ColorPicker;
export { ColorPicker, ColorPickerVue3 };